const styles = {
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    mapFull: {
        height: '80vh'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/page/PagePage.css.js